import React from "react";

const ProgressBar = ({ filledbgColor,unfilledBg,progressBarWidth,progressBarHeight, progress }) => {
  const containerStyles = {
    height: progressBarHeight, /* example:-  6px*/
    width: progressBarWidth, /* example:- 300px*/
    backgroundColor: unfilledBg,
    borderRadius: 50,
    // margin: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${progress}%`,
    background: filledbgColor,
    borderRadius: "inherit",
    textAlign: "right",
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
